import { useMutation } from '@tanstack/react-query';

import { ApiRoutes } from '@lib/enums';
import { useHttp } from '@lib/http';

import type { THttpResponse } from '@lib/types/THttpResponse';
import type { UseMutationResult } from '@tanstack/react-query';

type TClearInteractionsRequest = {
  contactId: string;
};

export const useMutationClearInteractions = (): UseMutationResult<
  THttpResponse<null>,
  Error,
  TClearInteractionsRequest
> => {
  const { http } = useHttp();
  return useMutation({
    mutationFn: (request) =>
      http
        .delete(ApiRoutes.Contacts.ClearInteractions)
        .setId(request.contactId)
        .sendx({ allowNoContent: true }),
  });
};
